(self["webpackChunk_dhl_account_app"] = self["webpackChunk_dhl_account_app"] || []).push([[620],{

/***/ 14620:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__.p + "i18n/nl-NL.733ef.json";

/***/ })

}])